/**
 * Copy to the clipboard, falling back to a hidden textarea where the async API is blocked
 * (in-app browsers, some iOS views). Resolves false when nothing was copied, so callers never
 * claim "Copied" for an empty clipboard.
 */
export async function copyText(text: string): Promise<boolean> {
  if (!text) return false;
  try {
    if (!navigator.clipboard?.writeText) throw new Error("no clipboard");
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const el = document.createElement("textarea");
      el.value = text;
      el.setAttribute("readonly", "");
      el.style.position = "fixed";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(el);
      return ok;
    } catch {
      return false;
    }
  }
}
